import { messageIdProvider, registerTranslationDivisions } from "infrastructure/localization";

export const glossaryDivision = "glossary";

registerTranslationDivisions([glossaryDivision]);

export const glossaryMessages = messageIdProvider(glossaryDivision);
